import { state, style, trigger } from '@angular/animations';
import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatPaginator } from '@angular/material/paginator';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable } from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import { NoDataComponent } from '@app/shared/components/no-data/no-data.component';
import { ReminderComponent } from '@app/shared/components/reminder/reminder.component';
import { ThrottleEventDirective } from '@app/shared/directives/throttle-event.directive';
import { FormatAdressPipe } from '@app/shared/pipes/formatadress.pipe';
import { FormatDatePipe } from '@app/shared/pipes/formatdate.pipe';
import { BasicPolizzeListComponent } from '../basic-polizze-list/basic-polizze-list.component';

@Component({
  selector:    'app-offerteantraege-schwebebestaende',
  templateUrl: './schwebebestaende.component.html',
  styleUrls:   ['./schwebebestaende.component.scss'],
  animations:  [
    trigger('detailExpand', [
      state('collapsed', style({
        display: 'none'
      })),
      state('expanded', style({
        height:     '*',
        visibility: 'visible'
      }))
    ])
  ],
  standalone:  true,
  imports: [
    NgIf,
    MatTable,
    MatSort,
    NgFor,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    MatIconButton,
    MatIcon,
    MatTooltip,
    ThrottleEventDirective,
    ReminderComponent,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    NgClass,
    MatPaginator,
    MatProgressSpinner,
    NoDataComponent,
    FormatDatePipe,
    FormatAdressPipe,
    AsyncPipe
  ]
})

export class OfferteAndAntraegeSchwebebestaendeComponent extends BasicPolizzeListComponent implements OnInit,
                                                                                                      OnDestroy {

  get displayedColumns(): string[] {
    const columns = this.tableColumns.map(c => c.columnDef);
    // Expand + alle spalten anzeigen + aktionen (ist im html definiert)
    columns.unshift('expand');
    if (this.bearbeitenErlaubt) {
      columns.push('aktionen');
    }
    return columns;
  }

  getAnzRowsPerEntry(): number {
    return 2;
  }

}
